function getSubmitData(el){
    return JSON.parse(el.dataset.json)
}

function getFileNameFromHeader(contentDisposition) {
    if (!contentDisposition) return null;
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    return match ? match[1] : null;
}

function showToast(){
    const toast_container = document.createElement("div")
    toast_container.className = "fixed bottom-5 right-5 z-50 space-y-3"
    toast_container.innerHTML = 
        `<div class="bg-red-50 p-2 border border-red-300 flex items-center justify-between rounded-md w-80 max-w-full">
            <p id="toast-message" class="text-sm">Download failed due to some internal error</p>
            <button class="text-sm font-bold  close-toast">✖</button>
        </div>
        `
    document.body.appendChild(toast_container);
    toast_container.querySelector(".close-toast").addEventListener("click", () => {
        toast_container.remove()
    })
    setTimeout(() => toast_container.remove(), 5000);
}

export function handlePdfDownloadRequest(el){
    el.classList.remove("hidden")
    el.addEventListener("click", function(e){
        const url = el.dataset.downloadUrl
        if (!url) return;
        const downloadIndicator = document.querySelector(el.dataset.downloadIndicator)
        if(downloadIndicator)
            downloadIndicator.classList.remove('hidden')
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(getSubmitData(el))
        })
        .then(response => {
            if(response.headers.get("content-type") !== "application/pdf"){
                response.text().then((resp) => {
                    showToast()
                })
                throw new Error("Failed to fetch PDF")
            }
            if (!response.ok) {
                throw new Error("Failed to fetch PDF");
            }
            const contentDisposition = response.headers.get('Content-Disposition');
            const filename = getFileNameFromHeader(contentDisposition) || "default.pdf";

            return response.blob().then(blob => ({ blob, filename }));
        })
        .then(({ blob, filename }) => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
            URL.revokeObjectURL(link.href);
        }).catch(function(err) {
            showToast()
            console.error('PDF download error:', err);
        }).finally(() => {
            if(downloadIndicator)
                downloadIndicator.classList.add('hidden')
        });
    })
}